<script>
    import Stamp from "../components/images/Stamp.svelte";
    import { business } from "../firebase/auth";
</script>

{#if $business}
    <h1>Stempel</h1>
    <section>
        <Stamp businessId={$business.id}/>
    </section>
{/if}